import { useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Printer } from 'lucide-react';
import Certificate from './Certificate';

export default function CertificateModal({
  isOpen,
  onClose,
  studentName,
  schoolName,
  achievement,
  date,
  type = 'monthly',
}) {
  const certificateRef = useRef(null);

  const handlePrint = () => {
    window.print();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 print:bg-white print:p-0"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-auto print:shadow-none print:rounded-none print:max-h-none"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-100 print:hidden">
              <h2 className="text-xl font-semibold text-gray-900">Your Certificate</h2>
              <div className="flex items-center gap-2">
                <button
                  onClick={handlePrint}
                  className="btn-ghost py-2 px-4 flex items-center gap-2"
                  title="Print certificate"
                >
                  <Printer size={18} />
                  <span className="hidden sm:inline">Print / Save as PDF</span>
                </button>
                <button
                  onClick={onClose}
                  className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center"
                >
                  <X size={20} className="text-gray-500" />
                </button>
              </div>
            </div>

            {/* Certificate */}
            <div className="p-4" id="certificate-print-area">
              <div ref={certificateRef}>
                <Certificate
                  studentName={studentName}
                  schoolName={schoolName}
                  achievement={achievement}
                  date={date}
                  type={type}
                  onPrint={handlePrint}
                />
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
